import clientConfigApi from '../../config/config'

export const playOnTV = async (token, chNumber) => {
    let responseData;
    let command = [
        "TV"
    ]
    if (chNumber.length === 1) {
        command.push(chNumber);
    } else {
        for (let i = 1; i <= chNumber.length; i++) {
            command.push(chNumber.charAt(i - 1));
        }
    }
    console.log("command", command);
    responseData = await channelApi(token, command);
    console.log("remote command respose", responseData);
}

export const playPrivous = async (token) => {
    let command = ["UP"]
    let responseData
    console.log("command", command);
    responseData = await channelApi(token, command);
    console.log("remote command respose", responseData);
}

export const playNext = async (token) => {
    let command = ["DOWN"]
    let responseData
    console.log("command", command);
    responseData = await channelApi(token, command);
    console.log("remote command respose", responseData);
}

export const makeMove = async (token, command) => {
    let responseData
    console.log("command", command,token);
    responseData = await channelApi(token, command);
    console.log("remote command respose", responseData);
}

const channelApi = (token, command) => {
    let response = clientConfigApi.post(
        "/remote/commands",
        {
            "header": {
                "remoteSessionToken": token
            },
            "payload": {
                "capsOn": false,
                "commands": command
            }
        },
        {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("tvRemotwAuthToken")}`
          }
        }
    )
        .catch(
            (response) => {
                console.log("Api failed with the status code:", response);
                // alert("you are connected to tv");
                if(window.FireBasePlugin){
                    // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
                    window.FirebasePlugin.logError("TV remote command api failed" + response)
                }
            }
        )
    return response;
}